import { useCallback } from 'react';
import { useUnifiedNotifications } from '../contexts/UnifiedNotificationContext';

export function useAdminFeedback() {
  const { notify } = useUnifiedNotifications();
  const success = useCallback(message => notify(message, 'success', { priority: true, duration: 4000 }), [notify]);
  const error = useCallback(message => notify(message, 'error', { priority: true, duration: 10000 }), [notify]);
  const copy = useCallback(async (value, label) => {
    try {
      await navigator.clipboard.writeText(value);
      success(`${label} copied.`);
      return true;
    } catch {
      error(`Could not copy ${label.toLowerCase()}. Select the text and copy it manually.`);
      return false;
    }
  }, [success, error]);
  return { success, error, copy };
}
